module.exports = __webpack_public_path__ + "img/farming-news-04.f486f959.png";